/* eslint-disable quotes */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable eol-last */

import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
    
}));